import {dynamicApiCall} from "./dynamicApiCall";

export const state = async (data) => {
  const option = {
    method: 'GET',
    endpoint: '/state/students-data/',
    data:data,
  }

  const response = await dynamicApiCall(option)

  if (response.status === 200) {
    return response
  } else {
    throw response
  }
};